import "./notfound.scss";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="notFoundPage">
      <div className="notFoundContainer">
        <div className="notFoundContent">
          <div className="errorIcon">📚</div>
          <h1>404</h1>
          <h2>Page Not Found</h2>
          <p>The page you're looking for doesn't exist.</p>

          <div className="actionButtons">
            <button className="btn btnPrimary" onClick={handleGoHome}>
              Go to Dashboard
            </button>
            <button className="btn btnSecondary" onClick={handleGoBack}>
              Go Back
            </button>
          </div>

          <div className="helpfulLinks">
            <p>Quick Access:</p>
            <div className="links">
              <a href="/" className="link">Dashboard</a>
              <a href="/" className="link">Students & Staff</a>
              <a href="/login" className="link">Login</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
